var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`md-layout-item md-size-${_vm.size} md-small-size-${
    _vm.size * 2
  } md-xsmall-size-100`},[_c('label',[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('p',[_vm._v("\n    "+_vm._s(_vm.value)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/pages/Purchases/Quotations/FField.vue